/**
 * @param {string | null} dateString
 * @param {string} formatLocale
 * @returns {string}
 */
function formatArticleDate(dateString, formatLocale) {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString(formatLocale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

module.exports = { formatArticleDate };
